import { defineSagaForService } from '@repo/core'
import { serviceConfig as bankingProductsServiceConfig } from './bankingProducts'
import { serviceConfig as cashMovementServiceConfig } from './cashMovement'
import {
  fileDownloadConfig as accountDetailFileDownloadConfig,
  serviceConfig as accountDetailServiceConfig,
} from './data'
import {
  fileDownloadConfig as fundFileDownloadConfig,
  serviceConfig as fundServiceConfig,
} from './fund'
import { serviceConfig as productsByTypeServiceConfig } from './productsByType'

export const serviceConfig = defineSagaForService({
  ...accountDetailServiceConfig,
  ...fundServiceConfig,
  ...cashMovementServiceConfig,
  ...bankingProductsServiceConfig,
  ...productsByTypeServiceConfig,
})

export const fileDownloadConfig = { ...accountDetailFileDownloadConfig, ...fundFileDownloadConfig }
